import axiosPrivate from 'config/axiosPrivate';

const isConsultantPage = (pageName) =>
  String(pageName).startsWith('/Consultant');

export const trackPageView = async (pageName) => {
  if (!pageName || isConsultantPage(pageName)) return;

  try {
    await axiosPrivate.patch(
      `/user/tracking/page-view?pageName=${encodeURIComponent(pageName)}`
    );
  } catch {
  }
};
